import type { QueryClient } from '@tanstack/react-query';

import { candidateBriefQueryKeys } from '@/modules/candidate-detail/queries/queryKeys';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { candidateSubmissionsAwaitingReviewQueryKeys } from '@/modules/hiring-manager/queries/useCandidateSubmissionsAwaitingReviewQuery';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';

/**
 * After a turn: Finlay may have created, changed or published a job, or decided on candidates, so the job lists, the
 * job and candidate pages, the candidate panel beside the chat, the reviews waiting on the HM and an editor about to
 * open read them again.
 */
export const refreshJobData = (queryClient: QueryClient) =>
  Promise.all(
    [
      jobsQueryKeys.all,
      candidateJobQueryKeys.all,
      candidateBriefQueryKeys.all,
      candidateSubmissionsAwaitingReviewQueryKeys.all,
    ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
